import {Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef} from "@angular/core";
import {CookieService} from "ngx-cookie-service";
import {Observable} from "rxjs/Observable";
import {Subscription} from "rxjs/Subscription";

@Directive({
  selector: "[ifLoggedIn]",
})
export class IfLoggedInDirective implements OnInit, OnDestroy {
  private _loggedIn: boolean;
  private _hasView: boolean = false;
  private subscription: Subscription;

  constructor(
    private template: TemplateRef<Object>,
    private viewContainer: ViewContainerRef,
    private cookieService: CookieService,
  ) {}

  @Input("ifLoggedIn")
  ifLoggedIn: boolean;

  private update() {
    const invert = (this.ifLoggedIn === false);
    const condition = invert ? !this._loggedIn : this._loggedIn;

    if (condition && !this._hasView) {
      this._hasView = true;
      this.viewContainer.createEmbeddedView(this.template);
    } else if (!condition && this._hasView) {
      this._hasView = false;
      this.viewContainer.clear();
    }
  }

  ngOnInit() {
    this._loggedIn = /^yes$/i.test(this.cookieService.get("logged_in"));
    this.update();

    this.subscription = Observable.interval(1000)
      .subscribe(
        () => {
          this._loggedIn = /^yes$/i.test(this.cookieService.get("logged_in"));
          this.update();
        },
      );
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /var/snowriders/app/src/app/if-logged-in.directive.ts